import {usePropertyDm} from "../../../../../__snowpack__/link/packages/dm/dist/dm.esm.js";
import MaterialLink from "../../../../../__snowpack__/pkg/@mui/material/Link.js";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import Breadcrumbs from "../../../../components/molecules/breadcrumbs/breadcrumbs.component.js";
import Table from "../../../../components/molecules/tables/table/table.component.js";
import MergeUnitFilterModule from "../../../../components/organisms/merge-unit-filter-module/merge-units-filter-module.component.js";
import {withReduxAndStyle} from "../../../../hoc/bridge.hoc.js";
import {useParseFilters} from "../../../../hooks/use-parse-filters.hook.js";
import {useTableState} from "../../../../hooks/use-table-state.js";
import {usePropertiesFilters} from "./merge-units-list.hook.js";
import {PropertyListContainer} from "./merge-units-list.styles.js";
let timer;
function MergeUnitsListPage({
  jwt,
  breadcrumbs,
  filters,
  baseRoute,
  search
}) {
  const {
    getDuplicatedPropertiesList
  } = usePropertyDm(jwt);
  const [listProperties, setPropertiesList] = useState([]);
  const [total, setTotal] = useState(0);
  const filterFormRef = useRef(null);
  const [listFilters, setListFilters] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [routeFiltersLoaded, setRouteFiltersLoaded] = useState(false);
  const {
    open,
    loading,
    accountList,
    propertyList,
    groupList,
    portfolioList,
    onOpenAutocomplete,
    onCloseAutocomplete,
    onRefetchField
  } = usePropertiesFilters(jwt, filterFormRef);
  const {
    routeFilters
  } = useParseFilters(listFilters, jwt, filters);
  const tableLimits = useMemo(() => [25, 50, 100], []);
  const {
    limit,
    onLimitChange,
    onOrderingChange,
    onPaginationChange,
    onRowSelect,
    onRowSelectAll,
    onSearch,
    ordering,
    page,
    pagination,
    selectedRows,
    term
  } = useTableState(listProperties, tableLimits, search);
  const onSubmitFilters = useCallback((values) => {
    onPaginationChange(1);
    setOpenFilter(false);
    setListFilters(values);
  }, [onPaginationChange]);
  const handleRemoveFilter = useCallback((filter) => {
    const newFilters = Object.fromEntries(Object.entries(listFilters).filter((item) => item[0] !== filter));
    setListFilters(newFilters);
  }, [listFilters]);
  const onResetFilters = useCallback(() => {
    filterFormRef.current?.setValues({
      account: [],
      portfolio: [],
      group: [],
      property: []
    });
  }, []);
  const parseFiltersToUrl = useCallback(() => {
    const parsedFilters = Object.entries(listFilters).map(([key, value]) => value.map((v) => `${key}=${v.id}`).join("&"));
    const searchTerm = term && `search=${term}`;
    return [...parsedFilters, searchTerm].join("&");
  }, [listFilters, term]);
  const getNormalizedData = useCallback((properties) => {
    return properties.map((item) => {
      return {
        id: item.id,
        name: /* @__PURE__ */ React.createElement(MaterialLink, {
          href: `${baseRoute}/${item.id}?${parseFiltersToUrl()}`,
          underline: "hover"
        }, item.name),
        account: item.account.name,
        total_units: item.total_units,
        unmatched_units: item.unmatched_units ? item.unmatched_units : 0
      };
    });
  }, [baseRoute, parseFiltersToUrl]);
  const headers = useMemo(() => [{
    name: "id",
    translate: "property.list.columns.id",
    hidden: true
  }, {
    name: "name",
    translate: "property.list.columns.property_name",
    sortable: true,
    sortName: "name"
  }, {
    name: "account",
    translate: "property.list.columns.account",
    sortable: true,
    sortName: "account"
  }, {
    name: "total_units",
    translate: "property.list.columns.units"
  }, {
    name: "unmatched_units",
    translate: "property.list.columns.unmatched_units"
  }], []);
  const filterEq = Object.keys(JSON.parse(JSON.stringify(filters))).length === Object.keys(routeFilters).length;
  useEffect(() => {
    if (Object.keys(listFilters).length === 0 && filterEq && !routeFiltersLoaded) {
      setListFilters((prevState) => ({
        ...prevState,
        ...routeFilters
      }));
      setRouteFiltersLoaded(true);
    }
  }, [filterEq, listFilters, routeFilters, routeFiltersLoaded]);
  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      getDuplicatedPropertiesList({
        search: term,
        limit,
        page,
        ordering
      }, {
        ...listFilters,
        portfolio__id: listFilters.portfolio,
        id: listFilters.property
      }).then((response) => {
        setPropertiesList(response.results);
        setTotal(response.count);
      });
    }, 500);
  }, [getDuplicatedPropertiesList, limit, listFilters, ordering, page, term]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PropertyListContainer, null, /* @__PURE__ */ React.createElement(Breadcrumbs, {
    breadcrumbs
  }), /* @__PURE__ */ React.createElement(MergeUnitFilterModule, {
    innerRef: filterFormRef,
    initialValues: listFilters,
    listFilters,
    onSubmit: onSubmitFilters,
    onReset: onResetFilters,
    drawerOpen: openFilter,
    onClose: () => setOpenFilter(false),
    onOpenDrawer: () => setOpenFilter(true),
    open,
    loading,
    accountList: accountList || [],
    portfolioList: portfolioList || [],
    groupList: groupList || [],
    propertyList: propertyList || [],
    onOpenAutocomplete,
    onCloseAutocomplete,
    onRefetchField,
    term,
    onSearch,
    onRemoveFilter: handleRemoveFilter
  }), /* @__PURE__ */ React.createElement(Table, {
    data: getNormalizedData(listProperties),
    headers,
    limit,
    onLimitChange,
    onOrderingChange,
    onPaginationChange,
    onRowSelect,
    onRowSelectAll,
    ordering,
    pagination,
    selectable: false,
    selectedRows,
    tableLimits,
    total
  })));
}
export default /* @__PURE__ */ React.memo(withReduxAndStyle(MergeUnitsListPage));
